import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { BarChart3 } from 'lucide-react';
import { BarChart, Bar, Cell, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import useIsMobile from '../../hooks/useIsMobile';

const PRIORITY_COLORS = {
  low: '#6b7280', normal: '#3b82f6', high: '#f59e0b', urgent: '#ef4444',
};

export const meta = {
  id: 'tickets_by_priority',
  category: 'tickets',
  titleKey: 'dashboard.widgets.ticketsByPriority',
  descriptionKey: 'dashboard.widgets.ticketsByPriorityDesc',
  defaultSize: 'md',
  icon: BarChart3,
};

export default function TicketsByPriorityWidget({ ctx }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const byPriority = ctx?.byPriority || [];

  return (
    <div className="card" style={{ height: '100%' }}>
      <div className="card-header">
        <div className="card-title">{t('dashboard.ticketsByPriority')}</div>
      </div>
      <ResponsiveContainer width="100%" height={isMobile ? 160 : 200}>
        <BarChart data={byPriority.map(p => ({ name: t(`tickets.priorities.${p.priority}`), count: parseInt(p.count), priority: p.priority }))}>
          <XAxis dataKey="name" tick={{ fill: 'var(--c-text-muted)', fontSize: 11 }} />
          <YAxis tick={{ fill: 'var(--c-text-muted)', fontSize: 11 }} />
          <Tooltip contentStyle={{ background: 'var(--c-surface)', border: '1px solid var(--c-border)', borderRadius: 8, fontSize: 12 }} />
          <Bar
            dataKey="count"
            radius={[4, 4, 0, 0]}
            style={{ cursor: 'pointer' }}
            onClick={(payload) => {
              if (payload?.priority) navigate(`/tickets?status=__active__&priority=${payload.priority}`);
            }}
          >
            {byPriority.map((p) => (
              <Cell key={p.priority} fill={PRIORITY_COLORS[p.priority] || '#6b7280'} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
